module.exports = __webpack_public_path__ + "assets/f88edb061db5e8829c7489c41f24f80b.mp3";